import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityAppStatus } from '@api/data-security';

export const getCoreDataSecurityAppStatusSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityAppStatus',
	receive: true,
	request: true,
	requestHandler: getDataSecurityAppStatus,
	retainDataOnRequest: true
});
